// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Contacts_wrapper__2S8GA","info":"Contacts_info__yc0LD","form-wrapper":"Contacts_form-wrapper__OzA13"};